import { useEffect, useImperativeHandle, useState } from 'react';
import Spacer from '../../../../components/layout/Spacer';
import Switch from '../../../../components/layout/switch';
import { isObjectNull } from '../../../../components/helpers/ObjectHelpers';
import { PilotAssignmentCommands } from '../../services/DispatcherActions';
import { isPilotAssignmentCompletable, isPilotAssignmentCompleted } from '../helpers/PilotAssignmentHelpers';
import { useSetHasEditableChanged } from '../hooks/usePilotAssignmentStore';

export const CompleteCard = (
    {
        ref,
        assignmentService,
        onPilotAssignmentChanged
    }) => {

    useImperativeHandle(ref, () => ({
        onPilotageChanged() {
            initialize(true);
        }
    }));

    const [show, setShow] = useState(false);
    const [isChecked, setIsChecked] = useState(false);
    const [isDirty, setIsDirty] = useState(false);

    const onHasEditableChanged = useSetHasEditableChanged();

    useEffect(() => {
        initialize()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        show &&
        <>
            <Spacer height={30} />
            <Switch
                onLabel="Utf&oslash;rt"
                onChange={onChange}
                checked={isChecked}
                isDirty={isDirty}
            />
        </>
    )

    function initialize() {
        const completeCommand = assignmentService.getCommandByCommandType(PilotAssignmentCommands.CompletePilotageReceipt);
        const isCompletable = isPilotAssignmentCompletable(assignmentService);

        setShow(isCompletable);

        if (isObjectNull(completeCommand)) {
            setIsChecked(isPilotAssignmentCompleted(assignmentService.assignment));
        } else {
            setIsChecked(completeCommand.BoolValueLevel1);
        }
        initializeIsDirty();
    }

    function onChange(e) {
        onUpdateAsync(e.value);
    }

    async function onUpdateAsync(isChecked) {

        setIsChecked(isChecked);

        await assignmentService.onCompleteAsync(isChecked);

        onPilotAssignmentChanged();
		onHasEditableChanged();
        initializeIsDirty();
    }

    function initializeIsDirty() {
        setIsDirty(assignmentService.hasCommandType(PilotAssignmentCommands.CompletePilotageReceipt));
    }
}
